<template>
  <div>
          <div style="margin-top: -30px; margin-right: 20px; margin-bottom: 15px">
      <CRow style="flex-flow: row-reverse">
        <!-- <input
          type="file"
          ref="file"
          style="display: none"
          @change="uploadProduct($event)"
        /> -->
        <!-- <CButton block color="primary" style="width:fit-content;" type="file" @click="$refs.file.click()">Import Products</CButton> -->
        <CButton
          block
          color="danger"
          style="width: fit-content; height: fit-content; margin-top: 0.5rem"
          @click="upload = true"
          >Import Catalog</CButton
        >
        <CButton
          block
          color="danger"
          @click="addproduct"
          style="
            width: fit-content;
            height: fit-content;
            margin-top: 0.5rem;
            margin-right: 10px;
            float: right;
          "
          >Add Catalog</CButton
        >
      </CRow>
    </div>

    <Upload :map="map" v-if="upload" @uploadcb="handlecb"></Upload>

    <CCard>
        
      <CCardHeader>
                <h3 style="margin-left: 20px; margin-top: 10px">Catalog</h3>
      </CCardHeader>
      <CCardBody>
        <CDataTable
          :items="items"
          :fields="columnName"
          :tableFilter="{ placeholder: 'search', label: 'Search' }"
          items-per-page-select
          :items-per-page="10"
          hover
          sorter
          pagination
        >
          <template #show_details="{ item, index }">
            <td class="py-2">
              <CButton
                color="danger"
                variant="outline"
                square
                size="sm"
                @click="toggleDetails(item, index)"
                >{{ Boolean(item._toggled) ? "Hide" : "Show" }}</CButton
              >
            </td>
          </template>
          <template #details="{ item }">
            <CCollapse
              :show="Boolean(item._toggled)"
              :duration="collapseDuration"
            >
              <CCardBody>
                <CMedia
                  :aside-image-props="{ src:order.imgUrl ,height: 102 }"
                  v-for="order in item.orders" :key="order.title"
                  style="margin-top:5px"
                  >
                  <h4>{{ order.title }}</h4>
                  <p class="text-muted">quantity: {{ order.qty }}</p>
                  <p class="text-muted">Price: {{ symbol }}{{ order.price }}</p>
                  <!-- <router-link :to="{ name: 'vieworder', params: { id: item.docid }}"> View Order</router-link> -->
                  </CMedia>
                  <CButton
                    size="sm"
                    color="info"
                    class="ml-1"
                    @click="passorder(item)"
                    >View Order</CButton
                  >
                  <CButton
                    size="sm"
                    color="info"
                    class="ml-1"
                    @click="models(item)"
                    >Update Order Status</CButton
                  >

              </CCardBody>
            </CCollapse>
          </template>

        </CDataTable>
      </CCardBody>
      <CModal title="Update Status" :show.sync="myModal" size="sm">
        <span>Update Order Status</span>
        <br />
        <CRow form class="form-group" :key="name">
          <CCol>
            <br />
            <input
              type="checkbox"
              id="Shipped"
              value="Shipped"
              v-model="selected"
            />
            &nbsp;
            <label for="Shipped">Shipped</label>
            <br />
            <input
              type="checkbox"
              id="Payment Recieved"
              value="Payment Recieved"
              v-model="selected"
            />
            &nbsp;
            <label for="Payment Recieved">Payment Recieved</label>
          </CCol>
        </CRow>
        <template #footer>
          <CButton @click="myModal = false">Cancel</CButton>
          <CButton @click="update()">Ok</CButton>
        </template>
      </CModal>
    </CCard>
      <div>
  </div>

  </div>
</template>
<script src="https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.8.0/jszip.js"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.8.0/xlsx.js"></script>
<script>
import firebase from "firebase";
import SelectTable from "../tables/SelectTable";
import moment from "moment";

export default {
  name: "producttable",
  components: {},
  data: () => {
    return {
      currentitem: {},
      chatid: "",
      myModal: false,
      key: "",
      name: "",
      collapseDuration: 0,
      details: [],
      userId: "",
      tranid: "",
      itemsvaluee: "",
      id: "",
      datavalue: "",
      updatedatavalue: "",
      options: ["update"],
      option1: ["Shipped", "Payment Recieved"],
      selected: [],
      selectedOption: "some value",
      items: [],
      symbol : localStorage.getItem("symbol"),
      itemdelete: null,
      checker: true,
      SelectTable,
      temp: [],
      time: "",
      json_data : [],
      columnName: [
        {
          key: "name",
          label: "Name",
        },
        {
          key: "Category",
          label: "Category count",
        },
        {
          key: "show_details",
          label: "Action",
          _style: "width:1%",
          sorter: false,
          filter: false,
        },
      ],
    };
  },

  methods: {
    models(item) {
      this.tranid = item.docid;
      this.chatid = item.chatID;
      this.currentitem = item;
      this.myModal = true;
    },
    passorder(item) {
      this.$router.push({
        name: "vieworder",
        params: {
          id: item,
        },
      });
    },
    clickHandler(e) {
    },
    update() {
      const db = firebase.firestore();
      db.collection("orders").doc(this.tranid).update({
        status: this.selected,
      });
      this.chatentry();
    },
    toggleDetails(item) {
      this.$set(this.items[item.id], "_toggled", !item._toggled);
      this.collapseDuration = 300;
      this.$nextTick(() => {
        this.collapseDuration = 0;
      });
    },
    getOrderList() {
      const db = firebase.firestore();
      let temp = 0;
      let self = this;
      db.collection("orders")
        .orderBy("orderDate", "desc")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            console.log(doc.data().orders[0].id)
            if(doc.data().orders){
              if (doc.data().orders[0].id == firebase.auth().currentUser.uid) {
              this.datavalue = {
                docid: doc.id,
                orderDate: moment(
                  new Date(doc.data().orderDate.seconds * 1000)
                ).format("MMMM Do YYYY,"),
                paymentType: doc.data().paymentType,
                total: self.symbol + " " + doc.data().total,
                address: doc.data().address.address,
                phone: doc.data().address.phone,
                status: doc.data().status,
                name: doc.data().address.name,
                transactionRef: doc.data().transactionRef,
                orders: doc.data().orders,
                prodtitle: doc.data().orders[0].title,
                prodimage: doc.data().orders[0].imgUrl,
                prodqty: doc.data().orders[0].qty,
                prodprice: doc.data().orders[0].price,
                length: doc.data().orders.length,
                chatID: doc.data().chatID,
                orderNumber: doc.data().orderNumber ?? "",
                peyk_oid: doc.data().peyk_oid,
                peyk_charge:doc.data().peyk_charge,
                peyk_symbol:doc.data().peyk_symbol
              };
              this.datavalue["id"] = temp;
              temp = temp + 1;
              this.items.push(this.datavalue);
              self.download()
            }
            }


          });
          console.log("over")
        })
        .catch((err) => {
          console.log(err);
        });
    },
    editOrder(item) {
      this.$router.push({
        name: "editproduct",
        params: {
          id: item.userid,
          data: item,
        },
      });
    },
    deleteOrder(item) {
      const db = firebase.firestore();
      db.collection("products")
        .doc(item.item.userid)
        .delete()
        .then(() => {
          this.$router.push("/productorder");
        });
    },
    viewOrder(item) {
      this.$router.push({
        name: "viewProduct",
        params: {
          id: item.id,
          data: item.item,
        },
      });
    },
    download(){
      this.json_data=[];
      let o_data = [];
      console.log(typeof(this.items))
      for(var i in this.items) {
        var item = this.items[i];
        this.json_data.push({
           "Order ID" : item.orderNumber,
            "Order Date" : item.orderDate,
            "Payment Type":item.paymentType,
            "Total": item.total,
            "Status": item.status,
            "Name":item.name,
            "Number of Items":item.length,
            "Phone":item.phone,
            "Address" : item.address,
        })
        let temp =  this.json_data[i];
        for(let d in item.orders){
          let item1 = item.orders[d];
          let name = "Item" + d;
          temp["Item " + d] = item1.title
          temp["Item Price " + d] = item1.price
        }
        this.json_data[i] = temp
     }
    },
  },
  getBadge(status) {
    switch (status) {
      case "Payment Recieved":
        return "success";
      case "Shipped":
        return "secondary";
      case "Pending":
        return "warning";

      default:
        "primary";
    }
  },
  created: function () {
    this.getOrderList();
  },
};
</script>
<style >
.headModify > table > thead > th {
  display: none;
}
input[type="file"] {
  display: none;
}
.custom-file-upload {
  background-color: #321fdb;
  border: 1px solid #ccc;
  display: inline-block;
  cursor: pointer;
  color: #fff;
  border: 0;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.25rem;
}
</style>
